import { persistReducer } from "redux-persist";
import { userPersistConfig } from "../config/userPersistConfig";
import userSlice from "../slices/userSlice";

export const userPersistedReducer = persistReducer(userPersistConfig, userSlice);